import { AxiosError } from 'axios'

export const checkIsMultiError = (error: AxiosError) => {

  if (error.request && error.request.response) {
    const parsedError = JSON.parse(error.request.response);
    return Object.entries(parsedError).some(([key, value]) => key !== 'fields' && Array.isArray(value));
  }

  return false;
}
